export default () => ({
  status: undefined,
  statusDelete: undefined,
  statusMark: undefined,
  items: [],
  newTvMessage: undefined,
  unreadCount: 0,
});
